import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicTeamBrand } from '../account/teamApi';
import { TeamBrandProvider } from './TeamBrandContext';

export default function PublicTeamBrandProvider({ children }) {
  const { search = '' } = useLocation();
  const teamId = new URLSearchParams(search).get('team') || '';
  const [loaded, setLoaded] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoaded(null);
    if (!/^C[A-Z0-9]{1,63}$/.test(teamId)) return undefined;
    getPublicTeamBrand(teamId).then(team => {
      if (!cancelled && team?.team_id === teamId) setLoaded({ teamId, team });
    }).catch(() => { if (!cancelled) setLoaded(null); });
    return () => { cancelled = true; };
  }, [teamId]);

  // Branding comes only from this explicit public link, never from a previous account's cache.
  const publicTeam = loaded?.teamId === teamId ? loaded.team : null;
  return <TeamBrandProvider publicTeam={publicTeam}>{children}</TeamBrandProvider>;
}
